<template>
    <div class="bordas acoes-content">
        <button type="button" class="btn btn-secondary btn-sm btn-acoes" @click="mostrar24()">
            <div class="dia-icone-botao">+24h</div>
            <strong>Mais de 24h: {{qutd}}</strong>
        </button>
    </div>
</template>

<script>
export default {
    computed: {
        listagem () {
            return this.$store.getters['leitos/getListagemFiltrada']
        },
        listagemFiltradaStatus () {
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        },
        qutd () {
            let count = 0;

            if (this.listagem) {
                this.listagem.forEach(i => {
                    let resp = this.controleTempoInternacao(i.DataHoraInternacao)
                    if (resp) count = count + 1
                });
            }
          
            return count
        }
    },
    methods: {
         controleTempoInternacao (dt) {
            if (dt == '' || dt == null) return false

            let data = new Date(
                parseInt(dt.substr(6,4)),
                (parseInt(dt.substr(3,2)) - 1),
                parseInt(dt.substr(0,2)),
                parseInt(dt.substr(11,2)),
                parseInt(dt.substr(14,2))
            )

            let difdias =  86400000
            let diferenca = new Date().getTime() - data

            if (diferenca > difdias) return true
            else return false
        },
        mostrar24 () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 21 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 21)
        },
    }
}
</script>

<style>
.dia-icone-botao {
    background-color: #de3341;
    margin-right: 6px;
    display: inline-block;
    color: #fff;
    text-align: center;
    font-weight: 700;
    width: 34px;
    font-size: .8rem;
    border-radius: 8px;
}
</style>

